export const formatNumber = (number: number) => {
  let result = "";
  const gapSize = 3;

  if (typeof number === "number") {
    const numsArray = String(number).split(".");
    const numeral = numsArray[0];

    let spaceBefore = numeral.length % gapSize;

    for (let i = 0; i < numeral.length; i++) {
      if (i === spaceBefore) {
        result = `${result} `;
        spaceBefore += 3;
      }
      result += numeral[i];
    }

    if (numsArray[1]) {
      return [result.trim(), numsArray[1]].join(".");
    }

    return result.trim();
  }

  return number || "0";
};

export const numberWithSpaces = (input?: number | string | null): string => {
  if (input === null || input === undefined) {
    return "";
  }

  return parseFloat((typeof input === "string" ? parseFloat(input) : input).toString()).toLocaleString("ru-RU", {
    maximumFractionDigits: 10,
  });
};
